/**
 * LlmLabWorkspace - LLM Prompt Engineering Workspace
 *
 * Wraps the existing LlmPlayground component in standalone/embedded mode.
 * Provides multi-tab support for comparing and iterating on prompts.
 *
 * Features:
 * - Prompt engineering with variables
 * - Model selection
 * - Simulation mode with user/warehouse context
 * - Debug panel for tool detection
 * - Prompt library integration
 */

import React from 'react';
import { Box } from '@mui/material';
import LlmPlayground from '../../LlmPlayground';

/**
 * LlmLabWorkspace Component
 *
 * @param {Object} colors - Theme colors object
 */
const LlmLabWorkspace = ({ colors }) => {
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        bgcolor: colors.background,
        overflow: 'hidden',
      }}
    >
      <LlmPlayground
        standalone={true}
        embedded={true}
        initialTabType="llm"
      />
    </Box>
  );
};

export default LlmLabWorkspace;
